import { useEffect } from 'react';
import warning from 'warning';

var useChildPropWarning = function useChildPropWarning(ariaDescribedBy) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      process.env.NODE_ENV !== "production" ? warning(!ariaDescribedBy, 'Passing "aria-describedby" as prop to the "Tooltip" child component is not allowed for accessibility reasons, the attribute is automatically populated to match the tooltip id.') : void 0;
    }, [ariaDescribedBy]);
  }
};

export { useChildPropWarning };
